// Import dependencies
import React, { useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

// Import Components, styles, media
import Navigation from './components/Navigation.js';
import './App.css';
import Logo from './components/Logo.js';

// Import pages you have completed:
// Home, Topics, Gallery, Contact, and Staff Pages 
import HomePage from './pages/HomePage.js';
import TopicsPage from './pages/TopicsPage.js';

import RecipesPage from './pages/RecipesPage.js';

// If your schema requires SHORT data input, then use the TABLE design.
import EditRecipePageTable from './pages/EditRecipePageTable.js';
import AddRecipePageTable from './pages/AddRecipePageTable.js';

// Define the function that renders the content in Routes, using State.
function App() {

  const [recipe, setRecipeToEdit] = useState([])

  return (
    <>
      <BrowserRouter>
          <header>
          <Logo/>
            <h1>Josh Flenniken - Software Developer</h1>
            {/* <p>A portfolio project showcasing my web development skills in a MERN environment.</p> */}
            <Navigation />
          </header>

          

          

          <main>
            <section>
                <Routes> 
                    {/* Add Routes for Home, Topics, Gallery, Contact, and Staff Pages.  */}
                    
                    <Route path="/" element={<HomePage />} />
                    <Route path="/RecipesPage" element={<RecipesPage setRecipe={setRecipeToEdit}/>} />
                    <Route path="/TopicsPage" element={<TopicsPage />} />
                 
                    {/* Use these if your schema requires LONG data input: */}
                    <Route path="/AddRecipePageTable" element={<AddRecipePageTable />} /> 
                    <Route path="/EditRecipePageTable" element={<EditRecipePageTable recipeToEdit={recipe} />} />

                </Routes>
              </section>
          </main>

          <footer>
            <p>&copy;2024 Josh Flenniken</p>
          </footer>

      </BrowserRouter>
    </>
  );
}

export default App;